import * as React from 'react';
import { LayoutGroup } from 'framer-motion';

export interface IAnimationLayoutGroupProps {
  children?: React.ReactNode;
  className?: string;
  id?: string;
}

export const AnimationLayoutGroup = ({ children, ...animation }: IAnimationLayoutGroupProps) => (
  <LayoutGroup {...animation}>{children}</LayoutGroup>
);
